import FunctionHelper from "../../../shared/helper/FunctionHelper";

export default class MimeType {
	private readonly _type: string;
	private readonly _subtype: string;
	private readonly _fileTypeId: number;

	constructor(value: string, fileTypeId?: number) {
		let parts: Array<string> = value.split('/');
		this._type = parts[0];
		this._subtype = parts[1];
		this._fileTypeId = FunctionHelper.applyValue(fileTypeId, 0);
	}

	public get type(): string {
		return this._type;
	}

	public get subtype(): string {
		return this._subtype;
	}

	public get fileTypeId(): number {
		return this._fileTypeId;
	}

	public toString(): string {
		return this.type + '/' + this.subtype;
	}
}